<div class="content-wrapper">
    <div class="temp-banner-01" data-aos="fade-up" data-aos-duration="800" data-aos-easing="ease-in-out">
        <section class='hero-header'>
            <div class="container">
                <p class="font-size-18 uppercase text-white font-weight-medium text-center pb-3" data-aos="zoom-in-up" data-aos-duration="800" data-aos-easing="ease-in-out">MH {{'Theme Design' | translate}}</p>
                <h2 class="display-5 text-color font-weight-semibold text-center text-white" data-aos="zoom-in-up" data-aos-delay="5" data-aos-duration="800" data-aos-easing="ease-in-out">
                    {{'Our Factory of Creating FANTASY' | translate}}
                </h2>
            </div>
        </section>
    </div>
    <div class="py-5 my-5">
        <section class="container">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-7" data-aos="slide-right" data-aos-duration="800" data-aos-easing="ease-in-out">
                    <h1 class="display-3 font-weight-semibold py-5 h-100">{{'Factory Introduction' | translate}}</h1>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-5" data-aos="fade" data-aos-duration="800" data-aos-easing="ease-in-out">
                    <p class="accent-text-color font-size-16 text-justify py-5 h-100">
                        {{"Our factory located at Kajang, Selangor Malaysia with appx 60,000 sqft. We have area of storage, spray booth, Kuka Robot room, 3D printer and other facilities." | translate}}
                    </p>
                </div>
            </div>
            <hr>

            <section class="mt-5 py-5" data-aos="fade" data-aos-duration="800" data-aos-easing="ease-in-out">
                <h2 class="display-4 font-weight-semibold">MH {{'Theme Design' | translate}} - {{'Factory' | translate}}</h2>
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-3">
                        <img class="h-100" src="/assets/images/factory/img1.jpg" width="100%">
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-3">
                        <img class="h-100" src="/assets/images/factory/img2.jpeg" width="100%">
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-3">
                        <div class="row h-100">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-6 mb-3">
                                <img src="/assets/images/factory/img3.jpeg" width="100%">
                            </div>
                            <div class="col-12 col-sm-12 col-md-12 col-lg-6 mb-3">
                                <img src="/assets/images/factory/img4.jpeg" width="100%">
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-3">
                        <div class="row h-100">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-6 mb-3">
                                <img src="/assets/images/factory/img5.jpeg" width="100%">
                            </div>
                            <div class="col-12 col-sm-12 col-md-12 col-lg-6 mb-3">
                                <img src="/assets/images/factory/img6.jpeg" width="100%">
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <hr>
            
            <section class="mt-5 py-5" data-aos="fade" data-aos-duration="800" data-aos-easing="ease-in-out">
                <h2 class="display-4 font-weight-semibold">{{'Spray Booth' | translate}}</h2>
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 mb-3">
                        <img class="h-100" src="/assets/images/spray-booth/img1.jpeg" width="100%">
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 mb-3">
                        <img class="h-100" src="/assets/images/spray-booth/img2.jpeg" width="100%">
                    </div>
                </div>
            </section>
            <hr>

            <section class="mt-5 py-5" data-aos="fade" data-aos-duration="800" data-aos-easing="ease-in-out">
                <h2 class="display-4 font-weight-semibold">{{'KUKA 5D Robotic Arm' | translate}}</h2>
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 mb-3">
                        <img class="h-100" src="/assets/images/kuka-arm/img1.jpeg" width="100%">
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 mb-3">
                        <img class="h-100" src="/assets/images/kuka-arm/img2.jpeg" width="100%">
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-9 mb-3">
                        <img class="h-100" src="/assets/images/kuka-arm/img5.jpeg" width="100%">
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-3 mb-3">
                        <img class="h-100" src="/assets/images/kuka-arm/img4.jpeg" width="100%">
                    </div>
                </div>
            </section>
            <hr>

            <section class="mt-5 py-5" data-aos="fade" data-aos-duration="800" data-aos-easing="ease-in-out">
                <h2 class="display-4 font-weight-semibold">{{'RESULT From KUKA 5D Robotic Arm' | translate}}</h2>
                <!-- <p class="accent-text-color font-size-16">- {{'Client with 3D file, our in-house operator shall transferred and convert the file to our Robotic Arm.' | translate}}</p> -->
                <!-- <p class="accent-text-color font-size-16">- {{'For client without 3D file, we provide the services of scanning the actual model or to create the 3D model before transferred to the Robotic Arm for the production.' | translate}}</p> -->
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-4 mb-3">
                        <img class="h-100" src="/assets/images/kuka-arm-result/img1.jpeg" width="100%">
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-4 mb-3">
                        <img class="h-100" src="/assets/images/kuka-arm-result/img2.jpeg" width="100%">
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-4 mb-3">
                        <img class="h-100" src="/assets/images/kuka-arm-result/img3.jpeg" width="100%">
                    </div>
                </div>
            </section>
            <hr>

            <section class="mt-5 py-5" data-aos="fade" data-aos-duration="800" data-aos-easing="ease-in-out">
                <h2 class="display-4 font-weight-semibold">{{'3D Printer' | translate}}</h2>
                <!-- <p class="accent-text-color font-size-16">- {{'3D printers of varies sizes from small, medium and large to cater for our clients’ need.' | translate}}</p> -->
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-8 mb-3">
                        <img class="h-100" src="/assets/images/3d-print/img2.jpeg" width="100%">
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-4 mb-3">
                        <img class="h-100" src="/assets/images/3d-print/img1.jpeg" width="100%">
                    </div>
                </div>
            </section>
            <hr>

            <section class="mt-5 py-5" data-aos="fade" data-aos-duration="800" data-aos-easing="ease-in-out">
                <h2 class="display-4 font-weight-semibold">{{'RESULT From 3D Printer' | translate}}</h2>
                <!-- <p class="accent-text-color font-size-16">- {{'Fine and smooth surface' | translate}}</p> -->
                <!-- <p class="accent-text-color font-size-16">- {{'Clear 3D model' | translate}}</p> -->
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-4 mb-3">
                        <img class="h-100" src="/assets/images/3d-print-result/img1.jpeg" width="100%">
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-4 mb-3">
                        <img class="h-100" src="/assets/images/3d-print-result/img2.jpeg" width="100%">
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-4 mb-3">
                        <img class="h-100" src="/assets/images/3d-print-result/img3.jpeg" width="100%">
                    </div>
                </div>
            </section>
            <hr>

            <section class="mt-5 py-5" data-aos="fade" data-aos-duration="800" data-aos-easing="ease-in-out">
                <h2 class="display-4 font-weight-semibold">{{'3D SCANNER - SCAN PROCESS' | translate}}</h2>
                <!-- <p class="accent-text-color font-size-16">- {{'A 3D scale model which will be created and approved by Client; Scan the scale model surface by a hand held scanner; With the scan model, an accurate quantities and better control profile can be achieved; For off site production, the scan data are used for pre-fabrication of mould, cage and etc; For on site installation, scan data are use for QA/QC control.' | translate}}</p> -->
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-8 mb-3">
                        <img class="h-100" src="/assets/images/img17.jpeg" width="100%">
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-4 mb-3">
                        <img class="h-100" src="/assets/images/img18.jpeg" width="100%">
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 mb-3">
                        <img class="h-100" src="/assets/images/img20.jpeg" width="100%">
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 mb-3">
                        <img class="h-100" src="/assets/images/img19.jpg" width="100%">
                    </div>
                </div>
            </section>
            <hr>

            <section class="mt-5 py-5" data-aos="fade" data-aos-duration="800" data-aos-easing="ease-in-out">
                <h2 class="display-4 font-weight-semibold">{{'3D SCALE MODEL' | translate}}</h2>
                <!-- <p class="accent-text-color font-size-16">- {{'3D Aquarium scale model' | translate}}</p> -->
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 mb-3">
                        <img class="h-100" src="/assets/images/img21.jpeg" width="100%">
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 mb-3">
                        <img class="h-100" src="/assets/images/img22.jpeg" width="100%">
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 mb-3">
                        <img class="h-100" src="/assets/images/img23.jpeg" width="100%">
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 mb-3">
                        <img class="h-100" src="/assets/images/img24.jpeg" width="100%">
                    </div>
                </div>
            </section>

        </section>
    </div>
</div>
